// import React from 'react';
import { connect } from 'react-redux';

import {
  MID_GET_PRD_PAGE_BRAND_STYLE,
  MID_GET_PRODUCT_DATA,
  MID_ADD_TO_FAVORITE,
  MID_REMOVE_TO_FAVORITE,
  MID_POST_ADD_WRITE_REVIEW,
  // MID_GET_POINT_OF_SERVICES,
  // MID_GET_COUPON_LIST_FOR_PRODUCT,
  // MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT,
  // MID_ADD_PRODUCT_ARRIVAL_NOTICE,
  // MID_REMOVE_PRODUCT_ARRIVAL_NOTICE,
  MID_POST_ADD_TO_CART_FOR_PRODUCT_PAGE,
  MID_POST_INSTANT_ADD_TO_CART_FOR_PRODUCT_PAGE,
} from '@js/constants/middlewareActionsTypes';

import {
  UPDATE_REQUEST_PRODUCT_CODE,
  // UPDATE_REQUEST_CHANGE_POINT,
  UPDATE_REQUEST_QTY,
  UPDATE_REQUEST_CATE_PATH,
  // UPDATE_REQUEST_DELIVERY_MODE,
  // UPDATE_REQUEST_DELIVERY_COST,
  UPDATE_REQUEST_ADDITIONAL_PURCHASES,
  // UPDATE_DELIVERY_MODE_CODE,
  CLOSE_EXCEPTION_MODAL,
} from '@js/constants/actionsTypes';

import ProductComponent from '@js/components/Layouts/Pages/Product/Product';

const mapStateToProps = (state) => {
// const { isMobile } = state.commonState;
// const { trplusOtherAlsoLikeProducts } = state.indexState;
  const { miniCartData } = state.cartState;
  const {
    //   simpleProductList,
    product,
    prdPageBrandStyle,
    //   pointOfServices,
    //   couponList,
    addToCartResponse,
    isShowExceptionModal,
    apiExceptionMessage,
    //   // request
    //   deliveryModeCode, // 用來判斷到底是 normal 還是 pickup，最後送 request 時要檢查, 不需送出
    requestProductCode, // 品號
    requestChangePoint, // 是否使用愛家卡點數 boolean
    requestQty, // 主商品數量
    requestCatePath, // 分類路徑、通路
    requestDeliveryMode, // 宅配方式（宅配：空值、店取：店名）
    requestDeliveryCost, // 其他服務（不安裝：nonInstallation、安裝：needInstallation）
    requestAdditionalPurchases, // 加購商品 arrayObject { sku: xxxx, qty: xx }
  } = state.productState;
  return {
    //   isMobile,
    //   trplusOtherAlsoLikeProducts,
    prdPageBrandStyle,
    product,
    miniCartData,
    //   pointOfServices,
    //   couponList,
    //   simpleProductList,
    addToCartResponse,
    isShowExceptionModal,
    apiExceptionMessage,
    //   // request
    //   deliveryModeCode,
    requestProductCode,
    requestChangePoint,
    requestQty,
    requestCatePath,
    requestDeliveryMode,
    requestDeliveryCost,
    requestAdditionalPurchases,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // Web & mobile
  // updateOtherAlsoLikeProduct: (payload) => dispatch({ type: MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT, payload }),
  // 獲取商品詳情
  getPrdPageBrandStyle: (payload) => dispatch({ type: MID_GET_PRD_PAGE_BRAND_STYLE, payload }),
  // 獲取商品詳情
  getProductData: (payload) => dispatch({ type: MID_GET_PRODUCT_DATA, payload }),
  // 加入喜愛
  postAddToFavorite: (payload) => dispatch({ type: MID_ADD_TO_FAVORITE, payload }),
  // 取消喜愛
  postRemoveToFavorite: (payload) => dispatch({ type: MID_REMOVE_TO_FAVORITE, payload }),
  // 加入購物車
  postAddToCart: (payload) => dispatch({ type: MID_POST_ADD_TO_CART_FOR_PRODUCT_PAGE, payload }),
  // 提交商品評價
  postAddWriteReview: (payload) => dispatch({ type: MID_POST_ADD_WRITE_REVIEW, payload }),
  // getPointOfServices: (payload) => dispatch({ type: MID_GET_POINT_OF_SERVICES, payload }),
  // getCouponListForProduct: (payload) => dispatch({ type: MID_GET_COUPON_LIST_FOR_PRODUCT, payload }),
  // postAddProductArrivalNotice: (payload) => dispatch({ type: MID_ADD_PRODUCT_ARRIVAL_NOTICE, payload }),
  // postRemoveProductArrivalNotice: (payload) => dispatch({ type: MID_REMOVE_PRODUCT_ARRIVAL_NOTICE, payload }),
  // // update request
  updateRequestProductCode: (payload) => dispatch({ type: UPDATE_REQUEST_PRODUCT_CODE, payload }),
  // updateRequestChangePoint: (payload) => dispatch({ type: UPDATE_REQUEST_CHANGE_POINT, payload }),
  // 改變商品數量
  updateRequestQty: (payload) => dispatch({ type: UPDATE_REQUEST_QTY, payload }),
  updateRequestCatePath: (payload) => dispatch({ type: UPDATE_REQUEST_CATE_PATH, payload }),
  // updateRequestDeliveryMode: (payload) => dispatch({ type: UPDATE_REQUEST_DELIVERY_MODE, payload }),
  // updateRequestDeliveryCost: (payload) => dispatch({ type: UPDATE_REQUEST_DELIVERY_COST, payload }),
  // 優惠加購
  updateRequestAdditionalPurchases: (payload) => dispatch({ type: UPDATE_REQUEST_ADDITIONAL_PURCHASES, payload }),
  // // 這個是用來比對店取 or 宅配的，之後方便跳錯誤訊息
  // updateDeliveryModeCode: (payload) => dispatch({ type: UPDATE_DELIVERY_MODE_CODE, payload }),
  // 立即結帳
  postInstantAddToCart: (payload) => dispatch({ type: MID_POST_INSTANT_ADD_TO_CART_FOR_PRODUCT_PAGE, payload }),
  // 關閉錯誤提示窗口
  closeExceptionModal: (payload) => dispatch({ type: CLOSE_EXCEPTION_MODAL, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductComponent);
